import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["control"]

  connect() {
    this.toggle()
  }

  toggle() {
    this.controlTargets.forEach((control) => {
      let shouldShowTarget = false

      if (["checkbox", "radio"].includes(control.type)) {
        shouldShowTarget = control.checked
      }

      document.querySelectorAll(control.dataset.targetQuerySelector).forEach((target) => {
        if (shouldShowTarget) {
          target.classList.remove("hidden")

          target.querySelectorAll("input").forEach((input) => {
            input.removeAttribute("disabled")
          })
        } else {
          target.classList.add("hidden")

          target.querySelectorAll("input").forEach((input) => {
            input.setAttribute("disabled", "")
          })
        }
      })
    })
  }
}
